import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../styles/adminDashboard.css";

const AdminDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate(); // ✅ added

  return (
    <div className="admin-dashboard">
      {/* HEADER */}
      <div className="admin-header">
        <h1>Admin Dashboard 👑</h1>
        <p>Welcome back, {user?.name || "Admin"}</p>
      </div>

      {/* STATS CARDS */}
      <div className="admin-cards">
        {/* ✅ MANAGE PUZZLES → ROUTING ADDED */}
        <div
          className="admin-card"
          onClick={() => navigate("/admin/add-puzzle")}
          style={{ cursor: "pointer" }}
        >
          <h3>Manage Puzzles</h3>
          <p>Manage all puzzles</p>
        </div>

        <div className="admin-card"
              onClick={()=>navigate("/admin/alter-tournament")}
        >
          <h3>Manage Tournaments</h3>
          <p>Create & control tournaments</p>
        </div>

        <div className="admin-card">
          <h3>Manage Users</h3>
          <p>View registered users</p>
        </div>

        <div className="admin-card"
             onClick={()=>navigate("/admin/add-notification")}
        >
          <h3>Add Notifications</h3>
          <p>Add new notifications</p>
        </div>

        <div className="admin-card">
          <h3>Update Results</h3>
          <p>Manage match results</p>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
